import i18n from './i18n';

const INTL_LOCALES: Record<string, string> = {
  de: 'de-AT',
  en: 'en-GB',
  it: 'it-IT',
  es: 'es-ES',
  zh: 'zh-CN',
};

const NUMBER_LOCALES: Record<string, string> = {
  de: 'de-DE',
  en: 'en-GB',
  it: 'it-IT',
  es: 'es-ES',
  zh: 'zh-CN',
};

export const localeFor = (lang?: string | null): string => INTL_LOCALES[(lang ?? 'en').slice(0, 2)] ?? 'en-GB';

export const currentLocale = (): string => localeFor(i18n.language);

export const numberLocale = (): string => NUMBER_LOCALES[(i18n.language ?? 'en').slice(0, 2)] ?? 'en-GB';

export const localeNumber = (value: number, options?: Intl.NumberFormatOptions): string =>
  Number(value).toLocaleString(numberLocale(), options);

export const localeDate = (value: string | number | Date): string =>
  new Date(value).toLocaleDateString(currentLocale(), { day: '2-digit', month: '2-digit', year: 'numeric' });

export const localeTime = (value: string | number | Date): string =>
  new Date(value).toLocaleTimeString(currentLocale(), { hour: '2-digit', minute: '2-digit' });
